import styled from '@emotion/styled';
import { maxBodyWidth, pxToRem } from '@lbcamden/lib-react';

import {
  ShowDetailsTrigger,
  ShowDetailsContent,
} from '~/client/components/common/ShowDetails/ShowDetails.styled';

export const HeaderRoot = styled.header`
  display: flex;
  justify-content: center;
  width: calc(100% + ${({ theme }) => theme.spacing(6)});
  max-width: revert;
  padding: ${({ theme }) => theme.spacing([0, 3])};
  background-color: ${({ theme }) => theme.colors.lightBlue};

  > * {
    ${maxBodyWidth}
    width: 100%;
  }
`;

export const HeaderContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing(4)};

  h1 {
    ${({ theme }) => theme.text.h1}
    align-self: flex-start;
    margin: ${({ theme }) => theme.spacing([0, 0, 2])};
  }

  address {
    align-self: flex-start;
    margin-bottom: ${({ theme }) => theme.spacing(4)};
    font-style: inherit;
  }

  ${ShowDetailsTrigger} {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }

  ${ShowDetailsContent} {
    align-self: flex-start;
    width: 100%;

    dl {
      padding-bottom: ${({ theme }) => theme.spacing(4)};
      margin-bottom: 0;
    }
  }

  dl {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: ${({ theme }) => theme.spacing(4)};
    align-self: flex-start;
    width: 100%;
    margin: 0;
    margin-bottom: ${({ theme }) => theme.spacing(4)};

    ${({ theme }) => theme.breakpoints.up('md')} {
      grid-template-columns: 1fr 1fr 1fr;

      dt {
        grid-row: 1;
      }

      dd {
        grid-row: 2;
      }
    }
    ${({ theme }) => theme.breakpoints.up('lg')} {
      width: calc(100% / 12 * 10);
    }
  }

  dd,
  dt {
    padding: ${({ theme }) => theme.spacing([2, 0])};
    margin: 0;
  }

  dt {
    ${({ theme }) => theme.text.h5}
  }
`;

export const HeaderButtonRow = styled('div')`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  align-self: stretch;

  > :nth-child(3) {
    justify-self: flex-end;
  }
`;
export const HeaderCautionLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(44)};
  height: ${pxToRem(44)};
  color: ${({ theme }) => theme.colors.amaranthRed};
`;
